import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DiaryOpeningTime, StoreViewModel } from '@models/api.models';
import { UmbracoImage } from '@models/umbraco.model';
import { GtmService } from '@core/services/gtm/gtm.service';
import { TranslateSafePipe } from '../../../../@shared/translate-safe/translate-safe.pipe';
import { ArrowLinkComponent } from '../../../../@shared/arrow-link/arrow-link.component';
import { SvgIconComponent } from '../../../../@shared/svg-icon/svg-icon.component';
import { ImageComponent } from '../../../../@shared/image/image/image.component';
import { NgIf, DatePipe } from '@angular/common';

@Component({
    selector: 'app-store-item',
    templateUrl: './store-item.component.html',
    styleUrls: ['./store-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, ImageComponent, SvgIconComponent, ArrowLinkComponent, DatePipe, TranslateSafePipe]
})
export class StoreItemComponent implements OnInit {
    public storePhoto: UmbracoImage;
    public openingTime: DiaryOpeningTime;
    @Input() store: StoreViewModel;

    constructor(public readonly gtmService: GtmService) {}

    ngOnInit(): void {
        if (!this.store) {
            return;
        }

        if (this.store.storePhotos && this.store.storePhotos.length > 0) {
            const { src = '', name, extension, type } = this.store.storePhotos[0];

            // this need to be mapped like this because the models are incompatible
            this.storePhoto = {
                src,
                name,
                extension,
                type
            };
        }

        const { openingTimes } = this.store;
        if (openingTimes && openingTimes.length) {
            // we will get the first day of this array
            this.openingTime = openingTimes[0];
        }
    }
}
